import React, {PureComponent, ReactNode} from 'react'

export class Footer extends PureComponent {

    render(): ReactNode {
        return (
            <div className="md:h-20 bg-neutral-700 text-white text-sm p-5">
                <div className="container h-full md:flex items-center justify-between">
                    <div className="flex justify-center items-center mb-6 md:mb-0">
                        <a href="https://www.repareo.de/">
                            <img src="/images/brand/logo-extra-light-blue.svg" className="w-32 h-auto" alt=""/>
                        </a>
                    </div>
                    <div
                        className="md:flex gap-3 grid grid-cols-2 justify-between items-center mb-6 md:mb-0">
                        <a href="https://www.repareo.de/impressum/"
                           className="text-white no-underline font-normal hover:underline">Impressum</a>
                        <a href="https://www.repareo.de/datenschutzerklaerung/"
                           className="text-white no-underline font-normal hover:underline">Datenschutzerklärung</a>
                        <a href="https://www.repareo.de/haftungsausschluss/"
                           className="text-white no-underline font-normal hover:underline">Haftungsausschluss</a>
                        <a href="https://lp.repareo.de/ws/registrierung-ihrer-werkstatt"
                           className="text-white no-underline font-normal hover:underline">Werkstatt
                            eintragen</a>
                    </div>
                    <div className="flex justify-center items-center">
                        <a href="https://www.repareo.de/"
                           className="text-white no-underline font-normal hover:underline">© {new Date().getFullYear()} repareo.de</a>
                    </div>
                </div>
            </div>
        )
    }
}
